// @ts-nocheck 585adcd8
import * as selectors from './componentMetaDataSelectors';
import * as actions from './componentMetaDataActions';

export { selectors, actions };
